// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2787e5dfdf--icon--3OVwr","expand":"_2787e5dfdf--expand--3zNzs"};